import types from './types'

const request = () => ({
  type: types.REQUEST_STORINGEN
})
const received = (storingen, formValues) => ({
  type: types.RECEIVED_STORINGEN,
  storingen,
  formValues
})
const failed = () => ({
  type: types.REQUEST_STORINGEN_FAILED
})

export default {
  request,
  failed,
  received
}


// WEBPACK FOOTER //
// ./src/actions/storingen.js